import React from 'react';
import Heading from '@atlaskit/heading';
import BookIcon from '@atlaskit/icon/glyph/book';
import NotificationIcon from '@atlaskit/icon/glyph/notification';
import { Flex, Text, Stack, xcss, Box } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { IconBox, IconBoxColor } from '../../../../../../../common/ui/icon-box';
import { WizardInfoItem } from '../../../../../../../common/ui/wizard/info-item';
import { messages } from './messages';

export const UserContent = () => {
	const { formatMessage } = useIntl();

	return (
		<Flex direction="column" rowGap="space.200">
			<Heading level="h800">{formatMessage(messages.titleNonFinal)}</Heading>
			<Text>{formatMessage(messages.descriptionNonFinal)}</Text>
			<Stack space="space.050">
				<Box xcss={listTitleWrapperStyles}>
					<Heading size="small" as="h2">
						{formatMessage(messages.listTitleNonFinal)}
					</Heading>
				</Box>
				<WizardInfoItem
					iconBox={
						<IconBox icon={NotificationIcon} color={IconBoxColor.Magenta} withCustomContainer />
					}
					description={formatMessage(messages.configureNotificationSettingsNonFinal)}
				/>

				<WizardInfoItem
					iconBox={<IconBox icon={BookIcon} color={IconBoxColor.Purple} withCustomContainer />}
					description={formatMessage(messages.learnHowToWorkNonFinal)}
				/>
			</Stack>
		</Flex>
	);
};

const listTitleWrapperStyles = xcss({ paddingTop: 'space.100', paddingBottom: 'space.100' });
